import api from '../api';

export const fetchStaff = (data) => api.post('/core/functions/fetchStaff', data);

export const fetchStaffMember = (data) => api.post('/core/functions/fetchStaffMember', data);

export const fetchSchools = (data) => api.post('/core/functions/fetchSchools', data);

export const fetchSchool = (data) => api.post('/core/functions/fetchSchool', data);
